import type { PaginatedDataTableColumnConfig } from '../types/paginatedDataTableTypes';

import { TemplateComponents } from './paginatedDataTableTemplates';

export const isKeyVisible = (columns: PaginatedDataTableColumnConfig[], columnKey: string) => {
  return !columns?.find((a) => a.field === columnKey)?.hidden;
};

export const getFilteredAndSortedColumns = (
  columns: PaginatedDataTableColumnConfig[],
  visibleColumns: string[],
) => {
  let columnKeysVisible: string[] = [];
  const storedVisibleColumns = visibleColumns ?? [];

  if (storedVisibleColumns.length) {
    columnKeysVisible = storedVisibleColumns.filter((key) => isKeyVisible(columns, key));
  } else if (columns?.length) {
    columnKeysVisible = columns
      .filter((column) => !column.hideInitial && !column.hidden)
      .map((column) => column.field);
  } else {
    columnKeysVisible = columns.map((column) => column.field);
  }

  const filteredAndSortedColumns = columns
    .filter((col) => columnKeysVisible.includes(col.field))
    .sort((a, b) => columnKeysVisible.indexOf(a.field) - columnKeysVisible.indexOf(b.field));

  return filteredAndSortedColumns;
};

export function getEffectiveTemplate(
  col: PaginatedDataTableColumnConfig,
): keyof typeof TemplateComponents | undefined {
  // Priority 1: Explicit template in config
  if (col.template && TemplateComponents[col.template]) {
    return col.template;
  }

  return undefined;
}
